import { TLogApiRequest } from '@monorepo/types';
import { uniqueId } from 'lodash';

export const STATELESS_UTIL = {
  generateLogId: (level: TLogApiRequest['level'], message: unknown, additional: unknown[], timestamp: Date): string => {
    if (level === 'UNHANDLED_ERROR') {
      const errorIdentifier = `${message}_${additional?.toString()}`;
      return `${level}_${STATELESS_UTIL.hashString(errorIdentifier)}`;
    }
    return uniqueId(`${level}_${timestamp.getTime()}`);
  },
  hashString: (input: string): string => {
    const hash = Array.from(input).reduce((acc, char) => {
      acc = (acc << 5) - acc + char.charCodeAt(0);
      return acc | 0; // Convert to 32bit int
    }, 0);
    return hash.toString();
  },
  // Capture the stack trace and extract the origin
  getLogOrigin: (): string => {
    const error = new Error();

    const stack = error.stack?.split('\n');

    if (stack && stack.length > 2) {
      const caller = stack[2];

      const match = caller.match(/([\w.-]+:\d+:\d+)/);
      if (match) {
        return match[1];
      }
    }
    return 'Unknown Origin';
  },
  sanitizeForLogging: (value: unknown): unknown => {
    if (typeof value === 'object' && value !== null) {
      if (value instanceof Error) {
        return { name: value.name, message: value.message, stack: value.stack };
      }
      if (typeof ProgressEvent !== 'undefined' && value instanceof ProgressEvent) {
        return { type: value.type, timeStamp: value.timeStamp };
      }
      try {
        return JSON.parse(JSON.stringify(value));
      } catch {
        return String(value);
      }
    }
    return value;
  },
};
